<!--系统管理页面弹窗组件  :rules="rules"-->
<template>
  <el-dialog
    title="客户列表"
    :visible="show"
    width="40%"
    @close="closeWindow"
    append-to-body
  >
    <div class="cu-title1">
      <div class="cu-title2">
        <div>客户姓名</div>
        <el-input size="medium" v-model="form1.customerName"></el-input>
      </div>
      <div class="cu-title2">
        <div>地址</div>
        <el-input size="medium" v-model="form1.address"></el-input>
      </div>
    </div>
    <div class="cu-title1">
      <div class="cu-title2">
        <div>联系方式</div>
        <el-input size="medium" v-model="form1.phone"></el-input>
      </div>
      <div class="cu-title3">
        <el-button type="primary" size="medium" @click="getDataList"
          >查询</el-button
        >
      </div>
    </div>
    <div style="margin: 20px 0">
      <el-table
        border
        :data="tableData"
        highlight-current-row
        @current-change="tableChange"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          fixed
          type="index"
          label="序号"
          width="50"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="customerName"
          label="姓名"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          show-overflow-tooltip
          label="联系方式"
        >
        </el-table-column>
        <!-- <el-table-column align="center" prop="isFree" :formatter="isFreeFormat" show-overflow-tooltip label="是否实体">
        </el-table-column> -->
        <el-table-column
          align="center"
          prop="customerTypeStr"
          show-overflow-tooltip
          label="用户类型"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="address"
          show-overflow-tooltip
          label="地址"
        >
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
      "
    >
      <el-button type="primary" @click="send">保存</el-button>
      <el-button @click="closeWindow">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import request from "@/utils/request.js"

export default {
  name: "CustomerList",
  props: {
    selectTableData: {
      type: Array,
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    typeParameter: [String, Number],
  },
  data() {
    return {
      form1: {
        customerName: "",
        address: "",
        phone: "",
      },
      tableData: [],
      query: {
        pageNum: 1,
        pageSize: 5,
      },
      totalCount: 0,
      customerName: "",
      customer: "",
      customerphone: "",
      address: "",
      idNumber: "",
      customerType: "",
      customerList: {},
      serviceStation: "",
      dataId: "",
    }
  },
  watch: {
    typeParameter: {
      handler(n, o) {
        this.getDataList(this.typeParameter)
      },
      deep: true, // 深度监听父组件传过来对象变化
    },
  },
  computed: {
    show() {
      return this.showStatus
    },
  },
  created() {},
  mounted() {},
  methods: {
    getDataList(n) {
      console.log(this.$route.path, "remnantOrder1")
      let params = {
        // type: 4,
        // isFree: "1",
        customerType: this.$route.path === "/remnantOrder1" ? 499 : 501,
        pageNo: this.query.pageNum,
        pageSize: this.query.pageSize,
        ...this.form1,
      }
      request({
        url: "/jjyl/admin/center/customer/info/findCanCreateWorkOrderList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content.list || []
            this.tableData.forEach((item) => {
              if (
                item.customerTypeStr != null &&
                item.customerTypeStr.indexOf("对象") == -1
              ) {
                //没找到返回-1
                item.customerTypeStr = ""
              }
            })
            // this.tableData.name = res.content.customerName
            this.totalCount = res.content.count || 0
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        }
      })
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.query.pageNum = val
      this.getDataList()
    },
    send() {
      this.$emit("send", {
        customerName: this.customerName,
        customer: this.customer,
        customerphone: this.customerphone,
        address: this.address,
        idNumber: this.idNumber,
        customerType: this.customerType,
        provinceId: this.provinceId,
        cityId: this.cityId,
        areaId: this.areaId,
        streetId: this.streetId,
        communityId: this.communityId,
        customerList: this.customerList,
        serviceStation: this.serviceStation,
        dataId: this.dataId,
      })
      this.closeWindow()
    },
    closeWindow() {
      this.$emit("update:showStatus", false)
      this.customerName = ""
      this.customer = ""
      this.customerphone = ""
      this.address = ""
      this.idNumber = ""
      this.provinceId = ""
      this.cityId = ""
      this.areaId = ""
      this.communityId = ""
      this.customerType = ""
      this.serviceStation = ""
      this.dataId = ""
    },
    tableChange(row) {
      if (row) {
        this.customerName = row.customerName
        this.customer = row.id
        this.customerphone = row.phone
        this.address = row.address
        this.customerType = row.customerType
        this.provinceId = row.provinceId
        this.cityId = row.cityId
        this.areaId = row.areaId
        this.streetId = row.streetId
        this.communityId = row.communityId
        this.customerList = row
        this.serviceStation = row.serviceStation
        this.dataId = row.dataId
      }
    },
    isFreeFormat(row, column) {
      if (row.isFree === "0") {
        return "否"
      } else if (row.isFree === "1") {
        return "是"
      }
    },
    typeFormat(row, column) {
      if (row.customerType === 1) {
        return "普通客户"
      } else if (row.customerType === 4) {
        return "老干服务对象"
      } else if (row.customerType === 6) {
        return "政府援助客户"
      } else if (row.customerType === 8) {
        return "D类援助客户"
      } else if (row.customerType === 3) {
        return "残联服务对象"
      } else if (row.customerType === 10) {
        return "文明办服务对象"
      } else if (row.customerType === 7) {
        return "商业服务对象"
      } else if (row.customerType === 13) {
        return "军人事务局服务对象"
      }
    },
  },
}
</script>
<style lang="less" scoped>
.cu-title1 {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.cu-title1 > div {
  width: 50%;
}

.cu-title2 {
  display: flex;
  align-items: center;
}

.cu-title2 > div:first-child {
  width: 80px;
  text-align: center;
}

.cu-title2 > div:nth-child(2) {
  width: calc(100% - 80px);
}

.cu-title3 {
  margin-left: 30px;
}
/deep/.el-input__suffix {
  margin-top: 0;
}
</style>
